import React from 'react';

import { TDetailedProps } from '@interlayer/js/app/components/main/Skeleton/types';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import style from './Detailed.scss';
import stylePageScroll from '@interlayer/js/app/components/main/Games/components/GameLayout/components/PageScroll/PageScroll.scss';
import styleDetailedTile from '@interlayer/js/app/components/main/Games/components/GameTile/components/DetailedTile/DetailedTile.scss';

export const Detailed: React.FC<TDetailedProps> = ({ count = 1 }) => (
    <div className={stylePageScroll.gameBlockContainer}>
        {Array.from({ length: count }, (_, index) => (
            <div key={index} className={clsx(style.item, styleDetailedTile.gameTile)} />
        ))}
    </div>
);
